<template>
  <div>
    <div class="dream">
      <div class="lef">
        <img src="http://aite.cnaite.cn/data/upload/shop/adv/06383984604938491.jpg" alt />
      </div>
      <div class="con" >
        <div v-for="item in listOne" :key="item.id">
          <div @click="goToDetail(item.id,item.pid)" class="title">{{item.title}}</div>
        </div>
        <div class="list" v-for="item in listTwo" :key="item.id">
          <li @click="goToDetail(item.id,item.pid)">{{ item.title }}</li>
        </div>
        <div class="meeting">
          <h3>电商会议</h3>
          <div class="meeting_box" v-for="item in commerce" :key="item.id" @click="goToDetail(item.id,item.pid)">
            <div class="lef">
              <img
                :src="item.imgurl"
                alt
              />
            </div>
            <div class="rig">
              <span class="name">{{item.title}}</span>
              <span class="time">{{item.addtime}}</span>
            </div>
          </div>
          
        </div>
      </div>
      <div class="rig">
        <div class="top">
          <img src="http://aite.cnaite.cn/data/upload/shop/adv/06383987941328654.png" alt />
        </div>
        <div class="zhineng">
          <div class="zn">智能商业</div>
          <div class="zhi" v-for="item in rigData" :key="item.id" @click="goToDetail(item.id,item.pid)">
            <div class="lef">
              <img
                :src="item.imgurl"
                alt
              />
            </div>
            <div class="rig">
              <span>{{item.title}}</span>
            </div>
          </div>
          
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import Qs from 'qs';
export default {
  data() {
    return {
      conData: [],
      rigData: [],
      listOne: [],
      listTwo: [],
      commerce: []
    }
  },
  created() {
    let params = {
      action: "top", classid: "61", count: "9", style: "home1"
    }
    axios.post('/ajax/ArchiveJson.ashx', Qs.stringify(params)).then((res) => {
      res.data.datalist.forEach(element => {
        element.pid = 61;
      });
      let Data = res.data.datalist2;
      this.listOne = res.data.datalist;
      this.listTwo = res.data.datalist2.concat(this.commerce);
      this.commerce = Data.splice(0,2);
      this.rigData = Data.splice(0,3);
      // console.log(res)
    })
  },
  methods:{
    goToDetail(value,pid){
      this.$router.push({path:'/sxy/detail',query:{id:value,classId:pid}})
    }
  }
}
</script>
<style scoped lang="scss">
.dream {
  display: flex;
  justify-content: space-between;
  .con {
    width: 323px;
    .title {
      color: #187adc;
      display: block;
      font-weight: normal;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      cursor: pointer;
      margin-bottom: 10px;
    }
    .list {
      margin-top: 3px;
      li {
        line-height: 26px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        color: #444444;
        font-size: 14px;
        cursor: pointer;
      }
      li:hover {
        color: #187adc;
      }
    }
    .meeting {
      h3 {
        font-size: 18px;
        color: #333333;
        font-weight: bold;
      }
      .meeting_box {
        display: flex;
        margin-bottom: 13px;
        cursor: pointer;
        .lef {
          img {
            width: 54px;
            height: 30px;
            margin-right: 10px;
          }
        }
        .rig {
          display: flex;
          flex-direction: column;
          .name {
            height: 20px;
            line-height: 20px;
            color: #333333;
            font-size: 10px;
            width: 200px;
            overflow: hidden;
            text-overflow:ellipsis;
            white-space: nowrap;
          }
          .time {
            font-size: 12px;
            color: #999999;
          }
        }
      }
    }
  }
  .rig {
    .zhineng {
      // height: 170px;
      overflow: hidden;
      .zn {
        font-size: 18px;
        color: #333333;
        font-weight: bold;
        margin-top: 10px;
        margin-bottom: 10px;
      }
      .zhi {
        display: flex;
        margin-bottom: 15px;
        cursor: pointer;
        .lef {
          img {
            width: 74px;
            height: 44px;
            margin-right: 10px;
          }
        }
        .rig {
          width: 180px;
          overflow: hidden;
          text-overflow:ellipsis;
          white-space: nowrap;
          span {
            font-size: 14px;
            color: #333333;
          }
        }
      }
    }
  }
}
</style>